import React from "react";
import cns from "classnames";
import { withStyles } from "@material-ui/core";
import { Classes, ThemeType } from "@theme";
import Title from "@components/typography/Title";
import Body from "@components/typography/Body";

type Props = {
  center?: boolean;
  children?: React.ReactNode;
  classes: Classes<typeof styles>;
  className?: string;
  mainText: string;
  smallText?: string;
};

const TableSubheader: React.FC<Props> = (props) => {
  const { classes, smallText } = props;
  const content = props.children || props.mainText;

  return (
    <div
      className={cns(classes.root, props.className, { [classes.center]: props.center })}
    >
      <Title component="span">{content}</Title>
      <Body className={classes.smallText}>{smallText}</Body>
    </div>
  );
};

const styles = (theme: ThemeType) => ({
  root: {
    display: "flex",
    flex: 1,
    alignItems: "baseline",
    background: "antiquewhite",
    borderBottom: `1px solid ${theme.palette.grey[200]}`,
    padding: 8
  },

  smallText: {
    marginLeft: theme.spacing(),
    fontSize: theme.typography.fontSize,
    opacity: 0.8
  },

  center: {
    justifyContent: "center"
  }
});

export default withStyles(styles as any)(TableSubheader);
